export const processElnObject = async (elnObject) => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "processElnObject",
            params: { eln_object: elnObject }
        })
    });

    const data = await response.json();
    return data;
};

export const processAndSaveElnObject = async (elnObject) => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "processAndSaveElnObject",
            params: { eln_object: elnObject }
        })
    });

    const data = await response.json();
    return data;
};

export const listElnObjects = async () => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "listElnObjects",
            params: {}
        })
    });

    const data = await response.json();
    return data;
};

export const processAndUpdateElnObject = async (id, elnObject) => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "processAndUpdateElnObject",
            params: { id, eln_object: elnObject }
        })
    });

    const data = await response.json();
    return data;
};

export const deleteElnObject = async (id) => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "deleteElnObject",
            params: { id }
        })
    });

    const data = await response.json();
    return data;
}

export const duplicateElnObject = async (id) => {
    const response = await fetch(`${process.env.REACT_APP_ELN_SERVER_URL}/obj`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            username: "gerard",
            func: "duplicateElnObject",
            params: { id }
        })
    });

    const data = await response.json();
    return data;
}